// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__17VhQ","buttons":"PendingPaymentAlert_buttons__25oal"};